function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a6770}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2782",
  className: "cls-1",
  d: "M33.417 1.319a6.827 6.827 0 0 1 7 6.64 6.827 6.827 0 0 1-7 6.64 6.827 6.827 0 0 1-7-6.64 6.827 6.827 0 0 1 7-6.64m0-1.806a8.694 8.694 0 0 0-8.9 8.446 8.694 8.694 0 0 0 8.9 8.446 8.694 8.694 0 0 0 8.9-8.446 8.694 8.694 0 0 0-8.9-8.446z",
  transform: "translate(-24.513 .487)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2783",
  className: "cls-1",
  d: "m46.29 18.9-3.875-3.67-.94-.037-.522-.416-.482.459-.482.459.436.5.061.873 3.876 3.665a.988.988 0 0 0 1.346 0l.584-.554a.87.87 0 0 0-.002-1.279z",
  transform: "translate(-25.256 -.993)"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4448",
    "data-name": "Group 4448",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.315 20",
    width: 21.315,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.68cc7359.svg";
export { ForwardRef as ReactComponent };